/**
 * 앱 커스텀 설정
 *   - 구조
 *     - antd: antd의 less 변수 커스텀(변경시 node 재시작 필요함), https://github.com/ant-design/ant-design/blob/master/components/style/themes/default.less
 *     - preference: antd 외 디자인에 사용된 스타일로 src/store/ThemeContext을 통해 앱 내에서 theme로 할당하여 사용 됨
 *     - menu: 메뉴 show/hide
 *   - 유의사항
 *     - antd 커스텀이 node에서 craco로 처리되기 때문에 import 사용 못함(require 사용)
 *     - src/store/ThemeContext에서 React의 context로 사용되기 때문에 본 파일은 src/ 폴더 밖에 위치하면 안됨(= Relative imports outside of src/ are not supported.)
 *     - 💥 값을 Spread Operator 혹은 Object.assign 으로 세팅하면 빌드시 에러가 발생한다.(참고: hanabank.failover)
 */

// FIXME antd 컬러나 preference의 경우 사이트 별로 동일할 수 있다 따라서 config의 preid가 사이트 명이 아닌 옵션별로 입력되어야할듯 ?...
// 일단 땜빵

const defaultColors = {
  '@text-color': '#5a6474',
  '@font-family': 'SpoqaHanSansNeo, sans-serif',
  '@layout-body-background': '#ffffff',
  '@layout-header-background': '#ffffff',
  '@layout-header-padding': '0 40px',
  '@layout-header-color': '@text-color',
  '@layout-sider-background-light': '#f8f8f9',
};

const defaultPreference = {
  appName: 'VD Portal',
  logo: 'logo.svg',
  copyright: {
    type: 'string',
    value: 'ⓒ SOMANSA',
  },
  serviceGuide: {
    text: '서비스 가이드',
    link: 'VDI_Manual.pdf',
    hide: false,
  },
  failover: {
    start: {
      text: '전원 켜기',
    },
    'soft-reboot': {
      text: '서비스 재부팅',
    },
    'hard-reboot': {
      text: 'Desktop 재부팅',
    },
  },
  customUrls: { passwordChange: 'default' },
};

const settings = {
  antd: {
    default: defaultColors,
    lgd: {
      '@primary-color': '#c00c3f',
    },
  },
  preference: {
    default: defaultPreference,
    lgd: {
      logo: 'logo_lgd.png',
      copyright: {
        type: 'image',
        value: 'copyright_lgd.png',
      },
      serviceGuide: {
        text: '접속 가이드',
        link: 'VDI_Manual_LGD.pdf',
        hide: false,
      },
      customUrls: {
        signUp: { windowFeatures: 'width=500,height=800,left=200,top=200,resizable=yes' },
        passwordReset: { windowFeatures: 'width=500,height=800,left=200,top=200,resizable=yes' },
      },
      protocolHandler: true,
    },
    hanabank: {
      logo: 'logo_hanabank.svg',
      copyright: {
        type: 'string',
        value: null,
      },
      customUrls: {
        passwordReset: { windowFeatures: 'width=1024,height=590,resizable=yes' },
        passwordChange: { windowFeatures: 'width=1024,height=590,resizable=yes' },
      },
      failover: {
        start: {
          text: '전원 켜기',
        },
        'soft-reboot': {
          text: '서비스 재부팅',
        },
        'hard-reboot': {
          text: 'Desktop 재부팅',
        },
        remoteHelpService: {
          text: '원격지원 서비스',
        },
      },
      autoLogin: {
        checked: true,
      },
      autoConnect: true,
      updateCheck: true,
    },
  },
  hideMenu: {
    default: [],
    hanabank: ['request', 'transfer'],
    lgd: [],
  },
  hideLoginMenu: {
    default: [],
    hanabank: ['signup', 'guide'],
    lgd: ['signup'],
  },
  redirectQuery: {
    default: false,
    hanabank: true,
    lgd: false,
  },
};

module.exports = {
  settings,
};
